export const unknownError = "Something went wrong";
